import React from 'react';
import './PlanSectionListItem.less';
import { CheckIcon } from 'app/components/icons';
import renderTextContent, {
  TextContentType,
} from 'utils/text/renderTextContent';

interface Props {
  itemIcon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text: TextContentType;
}

export default function PlanSectionListItem({
  itemIcon: ItemIcon = CheckIcon,
  text,
}: Props) {
  return (
    <li className="plan-section-list-item">
      <ItemIcon height={18} width={18} /> <span>{renderTextContent(text)}</span>
    </li>
  );
}
